import { StandardEvents } from '@shopify/events';

/**
 * Swaps between the purchase controls and the back-in-stock signup form
 * when the selected variant changes, mirroring the server-rendered state
 * from the fetched section HTML.
 */
class BackInStockContainer extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {CustomEvent & { promise: Promise<{ detail: { html?: Document, productId?: string } }> }} event
   */
  #handleProductSelect = (event) => {
    if (event.target instanceof Element && event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (detail.productId && detail.productId !== this.dataset.productId) return;

        const next = detail.html.querySelector(`back-in-stock-container[data-block-id="${this.dataset.blockId}"]`);
        if (!next) return;

        for (const selector of ['[data-purchase-controls]', '[data-signup]']) {
          const current = this.querySelector(selector);
          const updated = next.querySelector(selector);
          if (current && updated) current.hidden = updated.hidden;
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[back-in-stock] product select update failed:', error);
      });
  };
}

if (!customElements.get('back-in-stock-container')) {
  customElements.define('back-in-stock-container', BackInStockContainer);
}
